import { useEffect, useState } from 'react';

/**
 * Canonical responsive breakpoints for the dashboard.
 * Keep in sync with the values documented in src/styles/breakpoints.css.
 * mobile: <640px, tablet: 640-1023px, desktop: >=1024px
 */
export const BREAKPOINTS = {
  mobile: 640,
  tablet: 1024,
} as const;

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

export const useIsTabletAndBelow = () => useMediaQuery(`(max-width: ${BREAKPOINTS.tablet - 1}px)`);
export const useIsMobile = () => useMediaQuery(`(max-width: ${BREAKPOINTS.mobile - 1}px)`);
